import DiscordIcon from "./assets/discord.svg";
import FacebookIcon from "./assets/facebook.svg";
import InstagramIcon from "./assets/instagram.svg";
import TwitterIcon from "./assets/twitter.svg";

export const socials = [
  ["Discord", "/discord", DiscordIcon],
  ["Twitter", "https://twitter.com/GOPCBuild", TwitterIcon],
  ["Facebook", "https://www.facebook.com/GOPCBuild", FacebookIcon],
  ["Instagram", "https://www.instagram.com/gopcbuild/", InstagramIcon],
];
